// extracted by mini-css-extract-plugin
export default {"msgContainer":"Toast_msgContainer__tj8yi","msgTitle":"Toast_msgTitle__APNJF","msgText":"Toast_msgText__EiLGp"};